export default __webpack_public_path__ + "static/media/regulatory--no-good-trailers--g2.bad20402.png";